/* eslint-disable */
import {IDocument, IWorkflow} from "../../../modules/ninVerification/types";
import {IBusinessKycResponse} from "../../../app/modules/kyc/company/interfaces/IBusinessKycResponse";

export const CompanyKycWorkflowConstants = {
    KYC_COMPANY_START_FETCH: "KYC_COMPANY_START_FETCH",
    KYC_COMPANY_STOP_FETCH: "KYC_COMPANY_STOP_FETCH",
    KYC_COMPANY_COMMIT_FETCH: "KYC_COMPANY_COMMIT_FETCH",
    workflowsUpdateDocs: "workflowsUpdateDocs",

    verificationRequestsStartFetch: "verificationRequestsStartFetch"
}

export interface ICompanyKycWorkflowState {
    loading: boolean
    workflow?: IBusinessKycResponse
    verificationRequests?: []
}

const initialState: ICompanyKycWorkflowState = {
    workflow: undefined,
    verificationRequests: undefined,
    loading: false
}

export default function reducer(state = initialState, action: any) {
    switch (action.type) {

        case CompanyKycWorkflowConstants.verificationRequestsStartFetch: {
            return {...state, verificationRequests: action.payload}
        }

        case CompanyKycWorkflowConstants.KYC_COMPANY_START_FETCH: {
            return {...state, loading: true}
        }
        case CompanyKycWorkflowConstants.KYC_COMPANY_STOP_FETCH: {
            return {...state, loading: false}
        }

        case CompanyKycWorkflowConstants.KYC_COMPANY_COMMIT_FETCH: {
            const workflow: IBusinessKycResponse = action.payload
            return {...state, workflow, loading: true}
        }

        case CompanyKycWorkflowConstants.workflowsUpdateDocs: {
            const document: IDocument = action.payload
            if (state.workflow) {
                const documents = [...state.workflow.documents, document]
                const workflow = {...state.workflow, documents}
                return {...state, workflow}
            }
            return state
        }

        default: {
            return state
        }
    }
}


export function updateWorkflowDocs(document: IDocument) {
    return {
        type: CompanyKycWorkflowConstants.workflowsUpdateDocs,
        payload: document
    }
}

export function startWorkflowFetch() {
    return {type: CompanyKycWorkflowConstants.KYC_COMPANY_START_FETCH}
}

// export function fetchWorkflowAsync(caseId: string) {
//     const url = `${remoteRoutes.workflows}/${caseId}`
//     return (dispatch: Dispatch<any>) => {
//         get(
//             url,
//             resp => dispatch({type: workflowConstants.workflowsCommitFetch, payload: resp}),
//             undefined,
//             () => dispatch({type: workflowConstants.workflowsStopFetch})
//         )
//     };
// }
